<template>
	<div class="row mx-0 mb-2" style="padding-left: 1.5rem; position: relative;">

		<!-- delete item button -->
		<button v-if="source && !disabled" class="btn btn-secondary mt-1" @click.prevent="deleteThisItem" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-times"></i></button><!-- TODO -->

		<!-- list item index (arrays only) -->
		<div v-if="!isNaN(index)" class="col-0 p-0 pr-1 text-right mt-1" style="width: 3rem; !important; margin-left: -3rem !important;">
			<label class="col-form-label font-weight-bold">{{index+1}}</label>
		</div>

		<!-- value type selector -->
		<!--
			$string regex minlength	maxlength
			$number min minexclusive max maxexclusive precision
			$integer min(int) minexclusive max(int) maxexclusive
			$enum possiblevalues
			$flag
			$array mincount maxcount itemvaluetype itemvalidators
			$object objectschema keyformat mincount maxcount itemvaluetype itemvalidators
			$regex
			$novalue
		-->
		<div class="pr-0 pl-1 col-auto">
			<div class="input-group mt-1">
				<div class="input-group-prepend">
					<label class="input-group-text" :for="'validatorType_'+myHtmlId">Validator</label>
				</div>
				<select :id="'validatorType_'+myHtmlId" class="form-control" v-model="item.validator" :disabled="disabled">
					<option value="$string">String (Text) Format</option>
						<!-- OPTIONS: regex minlength maxlength -->
					<option value="$number">Number (Any) Settings</option>
						<!-- OPTIONS: min minexclusive max maxexclusive precision -->
					<option value="$integer">Integer Settings</option>
						<!-- OPTIONS: min(int) minexclusive max(int) maxexclusive -->
					<option value="$enum">Predefined Values</option>
						<!-- OPTIONS: possiblevalues -->
					<option value="$flag">Flag (true only) Validator</option>
					<option value="$reference">Object Reference</option>
					<option value="$array">Array (List) Settings</option>
						<!-- OPTIONS: mincount maxcount itemvaluetype itemvalidators -->
					<option value="$object">Object Settings</option>
						<!-- OPTIONS: objectschema keyformat mincount maxcount itemvaluetype itemvalidators -->
					<option value="$regex">Regular Expression</option>
					<option value="$novalue">No Value Allowed</option>
				</select>
			</div>
		</div>

		<template v-if="isAnyValidator( '$reference' )"> 
			
			<!-- Object Reference ID Settings -->
			<div class="pr-0 pl-1 col-12">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptIdRegex_'+myHtmlId">ID Regex</label>
					</div>
					<input :disabled="disabled" v-model="config.regex_id" type="text" class="form-control" :class="{'is-invalid':!validateRegex(config.regex_id)}" :id="'validatorOptIdRegex_'+myHtmlId" placeholder="Regular Expression for Object ID">
					<div class="input-group-append">
						<button @click.prevent="validateRegex( config.regex_id, true )" :disabled="!config.regex_id || !source" class="input-group-text btn btn-secondary">Test</button>
					</div>
				</div>
			</div>
			
			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" class="form-control mr-1" v-model="enableAllowedObjectIds" label="Limit Allowed Object IDs" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<button v-if="config.allowed_ids" :disabled="disabled" @click.prevent="addEnumValue( config.allowed_ids )" class="btn btn-info">Add Allowed Object ID</button>
			</div>

			<div v-if="config.allowed_ids" class="col-12 pl-1 pr-0">
				<object-editor-item :disabled="disabled" v-for="(v,index) in config.allowed_ids" :item="v" :source="config.allowed_ids"
					:index="index" :key="v._htmlId" :restricted-types="{ 'null' : false, 'string.block' : false, 'string.html' : false, object : false, array : false, date : false, image : false, file_any : false, reference : false, boolean : false }" />
			</div>

			<!-- Source Collection Name Settings -->
			<div class="pr-0 pl-1 col-12">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptColRegex_'+myHtmlId">Collection Regex</label>
					</div>
					<input :disabled="disabled" v-model="config.regex_collection" type="text" class="form-control" :class="{'is-invalid':!validateRegex(config.regex_collection)}" :id="'validatorOptColRegex_'+myHtmlId" placeholder="Regular Expression for Collection Name">
					<div class="input-group-append">
						<button @click.prevent="validateRegex( config.regex_collection, true )" :disabled="!config.regex_collection || !source" class="input-group-text btn btn-secondary">Test</button>
					</div>
				</div>
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" class="form-control mr-1" v-model="enableAllowedCollectionNames" label="Limit Allowed Collections" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<button v-if="config.allowed_collections" :disabled="disabled" @click.prevent="addEnumValue( config.allowed_collections )" class="btn btn-info">Add Allowed Collection Name</button>
			</div>

			<div v-if="config.allowed_collections" class="col-12 pl-1 pr-0">
				<object-editor-item :disabled="disabled" v-for="(v,index) in config.allowed_collections" :item="v" :source="config.allowed_collections"
					:index="index" :key="v._htmlId" :restricted-types="{ 'null' : false, number : false, 'string.block' : false, 'string.html' : false, object : false, array : false, date : false, image : false, file_any : false, reference : false, boolean : false }" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" v-model="config.no_self_collection" class="form-control mr-1" label="Disallow 'Self' Collection Source" />
			</div>

			<!-- Source Project ID Settings -->
			<div class="pr-0 pl-1 col-12">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptProjRegex_'+myHtmlId">Project Regex</label>
					</div>
					<input :disabled="disabled" v-model="config.regex_project" type="text" class="form-control" :class="{'is-invalid':!validateRegex(config.regex_project)}" :id="'validatorOptProjRegex_'+myHtmlId" placeholder="Regular Expression for Project ID">
					<div class="input-group-append">
						<button @click.prevent="validateRegex( config.regex_project, true )" :disabled="!config.regex_project || !source" class="input-group-text btn btn-secondary">Test</button>
					</div>
				</div>
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" class="form-control mr-1" v-model="enableAllowedProjectIds" label="Limit Allowed Projects" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<button v-if="config.allowed_projects" :disabled="disabled" @click.prevent="addEnumValue( config.allowed_projects )" class="btn btn-info">Add Allowed Project ID</button>
			</div>

			<div v-if="config.allowed_projects" class="col-12 pl-1 pr-0">
				<object-editor-item :disabled="disabled" v-for="(v,index) in config.allowed_projects" :item="v" :source="config.allowed_projects"
					:index="index" :key="v._htmlId" :restricted-types="{ 'null' : false, number : false, 'string.block' : false, 'string.html' : false, object : false, array : false, date : false, image : false, file_any : false, reference : false, boolean : false }" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" v-model="config.no_self_project" class="form-control mr-1" label="Disallow 'Self' Project Source" />
			</div>

			<!-- Source Node ID Settings -->

			<div class="pr-0 pl-1 col-12">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptNodeRegex_'+myHtmlId">Node Regex</label>
					</div>
					<input :disabled="disabled" v-model="config.regex_node" type="text" class="form-control" :class="{'is-invalid':!validateRegex(config.regex_node)}" :id="'validatorOptNodeRegex_'+myHtmlId" placeholder="Regular Expression for Node ID">
					<div class="input-group-append">
						<button @click.prevent="validateRegex( config.regex_node, true )" :disabled="!config.regex_node || !source" class="input-group-text btn btn-secondary">Test</button>
					</div>
				</div>
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" class="form-control mr-1" v-model="enableAllowedNodeIds" label="Limit Allowed Nodes" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<button v-if="config.allowed_nodes" :disabled="disabled" @click.prevent="addEnumValue( config.allowed_nodes )" class="btn btn-info">Add Allowed Node ID</button>
			</div>

			<div v-if="config.allowed_nodes" class="col-12 pl-1 pr-0">
				<object-editor-item :disabled="disabled" v-for="(v,index) in config.allowed_nodes" :item="v" :source="config.allowed_nodes"
					:index="index" :key="v._htmlId" :restricted-types="{ 'null' : false, number : false, 'string.block' : false, 'string.html' : false, object : false, array : false, date : false, image : false, file_any : false, reference : false, boolean : false }" />
			</div>

			<div class="col-auto pr-0 pl-1 mt-1">
				<input-checkbox :disabled="disabled" v-model="config.no_self_node" class="form-control mr-1" label="Disallow 'Self' Node Source" />
			</div>

		</template>

		<div v-if="isAnyValidator( '$number' )" class="col-12 row">
			<div class="col-auto pr-0 pl-1" style="max-width: 200px; max-height:42px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptPrecision_'+myHtmlId">Decimals</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptPrecision_'+myHtmlId" v-model.number="config.precision" min="0" max="10" step="1">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'precision')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="isAnyValidator( '$number', '$integer' )" class="col-12 row" style="max-height:42px;">
			<div class="col-auto pr-0 pl-1" style="max-width: 200px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptMin_'+myHtmlId">Min</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptMin_'+myHtmlId" v-model.number="config.min" :max="( config.max ? config.max : undefined )" :step="( item.validator === '$integer' ? 1 : ( !isNaN( config.precision ) ? Math.pow( 10, -config.precision ) : 0.1 ) )">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'min')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
			<div v-if="isAnyValidator( '$number' ) && !isNaN( config.min )" class="col-auto pr-0 pl-1">
				<input-checkbox :disabled="disabled" class="d-inline-block mt-1" v-model="config.minexclusive" label="Min Exclusive" />
			</div>
		</div>
		
		<div v-if="isAnyValidator( '$number', '$integer' )" class="col-12 row" style="height:42px;">
			<div class="col-auto pr-0 pl-1" style="max-width: 200px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptMax_'+myHtmlId">Max</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptMax_'+myHtmlId" v-model.number="config.max" :min="( config.min ? config.min : undefined )" :step="( item.validator === '$integer' ? 1 : ( !isNaN( config.precision ) ? Math.pow( 10, -config.precision ) : 0.1 ) )">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'max')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
			<div v-if="isAnyValidator( '$number' ) && !isNaN( config.max )" class="col-auto pr-0 pl-1">
				<input-checkbox :disabled="disabled" class="d-inline-block mt-1" v-model="config.maxexclusive" label="Max Exclusive" />
			</div>
		</div>

		<div v-if="isAnyValidator( '$string' )" class="col-12 row">
			<div class="col-auto pr-0 pl-1" style="max-width: 240px; max-height:42px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptMinLength_'+myHtmlId">Min Length</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptMinLength_'+myHtmlId" min="0" :max="( config.maxlength ? config.maxlength : undefined )" step="1" v-model.number="config.minlength">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'minlength')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="col-auto pr-0 pl-1" style="max-width: 240px; max-height:42px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptMaxLength_'+myHtmlId">Max Length</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptMaxLength_'+myHtmlId" :min="( config.minlength ? config.minlength : 0 )" step="1" v-model.number="config.maxlength">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'maxlength')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="isAnyValidator( '$string' )" class="pr-0 pl-1 col-12">
			<div class="input-group mt-1">
				<div class="input-group-prepend">
					<label class="input-group-text" :for="'validatorOptRegex_'+myHtmlId">Regex</label>
				</div>
				<input :disabled="disabled" v-model="config.regex" type="text" class="form-control" :class="{'is-invalid':!validateRegex(config.regex)}" :id="'validatorOptRegex_'+myHtmlId" placeholder="Regular Expression">
				<div class="input-group-append">
					<button @click.prevent="validateRegex( config.regex, true )" :disabled="!config.regex || !source" class="input-group-text btn btn-secondary">Test</button>
				</div>
			</div>
		</div>

		<div v-if="isAnyValidator( '$object' )" class="pr-0 pl-1 col-12">
			<div class="input-group mt-1">
				<div class="input-group-prepend">
					<label class="input-group-text" :for="'validatorOptItemSchema_'+myHtmlId">Object Schema</label>
				</div>
				<select :id="'validatorOptItemSchema_'+myHtmlId" class="form-control" v-model="config.objectschema" :disabled="disabled">
					<option :value="undefined">- No Schema Restriction -</option>
					<!-- <option value="*">- Any Schema -</option> --><!-- TODO: Review backend for this feature -->
					<option v-for="( schema, name ) in schemas" :key="name" :value="name">{{name}}</option>
				</select>
			</div>
		</div>

		<div v-if="isAnyValidator( '$object' ) && !config.objectschema" class="pr-0 pl-1 col-12">
			<div class="input-group mt-1">
				<div class="input-group-prepend">
					<label class="input-group-text" :for="'validatorOptKeyFormat_'+myHtmlId">Key Format</label>
				</div>
				<input :disabled="disabled" v-model="config.keyformat" type="text" class="form-control" :class="{'is-invalid':!validateRegex(config.regex)}" :id="'validatorOptKeyFormat_'+myHtmlId" placeholder="Regular Expression">
				<div class="input-group-append">
					<button @click.prevent="validateRegex( config.keyformat, true )" :disabled="!config.keyformat || !source" class="input-group-text btn btn-secondary">Test</button>
				</div>
			</div>
		</div>

		<div v-if="isAnyValidator( '$array' ) || ( isAnyValidator( '$object' ) && !config.objectschema )" class="col-12 row">
			<div class="col-auto pr-0 pl-1" style="max-width: 240px; max-height:42px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptMinCount_'+myHtmlId">Min Count</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptMinCount_'+myHtmlId" min="0" :max="( config.maxcount ? config.maxcount : undefined )" step="1" v-model.number="config.mincount">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'mincount')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="col-auto pr-0 pl-1" style="max-width: 240px; max-height:42px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptMaxCount_'+myHtmlId">Max Count</label>
					</div>
					<input :disabled="disabled" type="number" class="form-control" :id="'validatorOptMaxCount_'+myHtmlId" :min="( config.mincount ? config.mincount : 0 )" step="1" v-model.number="config.maxcount">
					<div v-if="!disabled" class="input-group-append">
						<button @click.prevent="$delete(config,'maxcount')" class="input-group-text btn btn-warning"><i class="fas fa-times"></i></button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="isAnyValidator( '$array' ) || ( isAnyValidator( '$object' ) && !config.objectschema )" class="col-12 row">
			<div class="col-auto pr-0 pl-1" style="max-width: 300px; max-height:42px;">
				<div class="input-group mt-1">
					<div class="input-group-prepend">
						<label class="input-group-text" :for="'validatorOptItemValuetype_'+myHtmlId">Item Valuetype</label>
					</div>

					<select class="form-control" :disabled="disabled" v-model="config.itemvaluetype" :id="'validatorOptItemValuetype_'+myHtmlId">
						<option :value="undefined">- Any Type -</option>
						<option :value="['string']">Text String</option>
						<option :value="['number']">Number</option>
						<option :value="['date']">Date</option>
						<option :value="['boolean']">Boolean (On/Off)</option>
						<option :value="['reference']">Reference</option>
						<!-- <optgroup label="Binary (File)">
							<option value="image">Image</option>
							<option value="file_any">Any File</option>
						</optgroup> -->
						<option :value="['array']">List (Array)</option>
						<option :value="['object']">Object</option>
					</select>
				</div>
			</div>
			<!-- NEW LINE AT THE END -->
			<div v-if="!disabled" class="col-auto pl-1 pr-0" style="max-height:42px;">
				<button @click.prevent="addItemValidator" class="btn btn-info mt-1"><i class="fas fa-plus"></i> Add Item Validator</button>
			</div>
		</div>

		<template v-if="isAnyValidator( '$object', '$array' )">
			<schema-field-validator :disabled="disabled" v-for="(v,index) in config.itemvalidators" :item="v" :key="v._htmlId" :index="index" :source="config.itemvalidators" :schemas="schemas" />
		</template>

		<div v-if="isAnyValidator( '$enum' ) && !disabled" class="col-auto pl-1 pr-0">
			<button @click.prevent="addEnumValue( config.possiblevalues )" class="btn btn-info mt-1">Add Value</button>
		</div>

		<div v-if="isAnyValidator( '$enum' )" class="col-12 pl-1 pr-0">
			<object-editor-item :disabled="disabled" v-for="(v,index) in config.possiblevalues" :item="v" :source="config.possiblevalues"
				:index="index" :key="v._htmlId" :restricted-types="{ object : false, array : false, date : false, image : false, file_any : false, reference : false }" />
		</div>
		
	</div>
</template>

<script>
// import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import SchemaFieldValidator from "@/components/utilities/SchemaFieldValidator";
import InputCheckbox from "@/components/utilities/InputCheckbox";
import ObjectEditorItem from "@/components/utilities/ObjectEditorItem";
import mixinObjectEditing from "@/components/mixins/objectEditing.js";
import _ from "lodash";
import { randomString } from '../../util';

import Vue from 'vue';

export default {
	name: "schema-field-validator",
	props: {
		item : { type : Object, required : true },
		index : { type : Number },
		source : { type : Array },
		htmlId : { type : String },
		disabled : { type : Boolean },
		schemas : { type : Object, required : true },	// List of this project's schemas for object validators.
	},
	mixins: [
		mixinObjectEditing
	],
	data() {
		return {
			_fieldIdIndex : null,
			enableAllowedObjectIds : false,
			enableAllowedCollectionNames : false,
			enableAllowedProjectIds : false,
			enableAllowedNodeIds : false,
			config : { possiblevalues : [], itemvalidators : [] },
			myHtmlId : randomString( ),
		};
	},
	components: {
		SchemaFieldValidator,
		InputCheckbox,
		ObjectEditorItem,
		//ObjectEditorSchema : () => import( "@/components/utilities/ObjectEditorSchema" )
	},
	created( )
	{
		if( this.htmlId )
			this.myHtmlId = this.htmlId;

		//alert( "TODO: Construct the config object. Don't forget the convert $enum values to editing structures." );
		
		// Abort, if no valid configs.
		if( !this.item.config || typeof this.item.config !== 'object' )
			return;

		// First copy over all values that need to be converted to editor-items.
		if( Array.isArray( this.item.config.allowed_ids ) )
		{
			this.$set( this.config, 'allowed_ids', this.item.config.allowed_ids.map( v => this.valueToEditorItem( v ) ) );
			this.enableAllowedObjectIds = true;
		}
		if( Array.isArray( this.item.config.allowed_collections ) )
		{
			this.$set( this.config, 'allowed_collections', this.item.config.allowed_collections.map( v => this.valueToEditorItem( v ) ) );
			this.enableAllowedCollectionNames = true;
		}
		if( Array.isArray( this.item.config.allowed_projects ) )
		{
			this.$set( this.config, 'allowed_projects', this.item.config.allowed_projects.map( v => this.valueToEditorItem( v ) ) );
			this.enableAllowedProjectIds = true;
		}
		if( Array.isArray( this.item.config.allowed_nodes ) )
		{
			this.$set( this.config, 'allowed_nodes', this.item.config.allowed_nodes.map( v => this.valueToEditorItem( v ) ) );
			this.enableAllowedNodeIds = true;
		}
		if( Array.isArray( this.item.config.possiblevalues ) )
			this.$set( this.config, 'possiblevalues', this.item.config.possiblevalues.map( v => this.valueToEditorItem( v ) ) );
		
		// Copy over all remaining properties of the source configs.
		const config = _.omit( this.item.config, [ 'possiblevalues', 'allowed_nodes', 'allowed_projects', 'allowed_collections', 'allowed_ids' ] )
		for( let f in config )
			this.$set( this.config, f, _.cloneDeep( this.item.config[f] ) );
	},
	watch:
	{
		enableAllowedObjectIds( newVal, oldVal )
		{
			if( !newVal )
				this.$delete( this.config, 'allowed_ids' );
			else if( !Array.isArray( this.config.allowed_ids ) )
				this.$set( this.config, 'allowed_ids', [] );
			
		},
		enableAllowedCollectionNames( newVal, oldVal )
		{
			if( !newVal )
				this.$delete( this.config, 'allowed_collections' );
			else if( !Array.isArray( this.config.allowed_collections ) )
				this.$set( this.config, 'allowed_collections', [] );
		},
		enableAllowedProjectIds( newVal, oldVal )
		{
			if( !newVal )
				this.$delete( this.config, 'allowed_projects' );
			else if( !Array.isArray( this.config.allowed_projects ) )
				this.$set( this.config, 'allowed_projects', [] );
		},
		enableAllowedNodeIds( newVal, oldVal )
		{
			if( !newVal )
				this.$delete( this.config, 'allowed_nodes' );
			else if( !Array.isArray( this.config.allowed_nodes ) )
				this.$set( this.config, 'allowed_nodes', [] );
		},
		config : {
			deep : true,
			handler( newVal, oldVal )
			{
				let configSchema = `$validatorconfig.${this.item.validator}.`;
				let saveConfig;
				switch( this.item.validator )
				{
					case '$reference': {
						saveConfig = _.pick( this.config, [ 'regex_id', 'regex_collection', 'regex_project', 'regex_node' ] );
						saveConfig.no_self_collection = ( this.config.no_self_collection || undefined );
						saveConfig.no_self_project = ( this.config.no_self_project || undefined );
						saveConfig.no_self_node = ( this.config.no_self_node || undefined );
						if( Array.isArray( this.config.allowed_ids ) )
							saveConfig.allowed_ids = this.config.allowed_ids.map( v => v.value );
						if( Array.isArray( this.config.allowed_collections ) )
							saveConfig.allowed_collections = this.config.allowed_collections.map( v => v.value );
						if( Array.isArray( this.config.allowed_projects ) )
							saveConfig.allowed_projects = this.config.allowed_projects.map( v => v.value );
						if( Array.isArray( this.config.allowed_nodes ) )
							saveConfig.allowed_nodes = this.config.allowed_nodes.map( v => v.value );
						break;
					}
					case '$string': {
						saveConfig = _.pick( this.config, [ 'regex', 'minlength', 'maxlength' ] );
						break;
					}
					case '$integer': {
						configSchema = `$validatorconfig.$number.$integer.`;	// Special case.
						saveConfig = _.pick( this.config, [ 'min', 'minexclusive', 'max', 'maxexclusive' ] );
						break;
					}
					case '$number': {
						saveConfig = _.pick( this.config, [ 'min', 'minexclusive', 'max', 'maxexclusive', 'precision' ] );
						break;
					}
					case '$enum': {	// Special case: Must go through and extract the actual values, not the editing structures.
						saveConfig = { possiblevalues : [] };
						for( let i=0; i < this.config.possiblevalues.length; i++ )
						{
							const value = this.config.possiblevalues[i].value;
							if( typeof value !== 'undefined' )
								saveConfig.possiblevalues.push( value );
						}
						break;
					}
					case '$array': {
						saveConfig = _.pick( this.config, [ 'mincount', 'maxcount', 'itemvaluetype', 'itemvalidators' ] );
						break;
					}
					case '$object': {
						if( this.config.objectschema )
							saveConfig = { objectschema : this.config.objectschema };
						else
							saveConfig = _.pick( this.config, [ 'keyformat', 'mincount', 'maxcount', 'itemvaluetype', 'itemvalidators' ] );
						break;
					}
					default: {
						// Nothing.. just don't set the saveConfig
					}
				}
				if( saveConfig )
				{
					saveConfig.$schema = configSchema;
					this.$set( this.item, 'config', saveConfig );
				}
				else
					this.$delete( this.item, 'config' );

			}
		}
	},
	computed:
	{

	},
	methods:
	{
		addItemValidator( )
		{
			this.$set( this.config.itemvalidators, this.config.itemvalidators.length, { $schema : "$validatorinclude.", validator : '$string', config : { } } );
		},
		addEnumValue( field )
		{
			this.$set( field, field.length, this.valueToEditorItem( '' ) );
		},
		validateRegex( regexString, showMessage )
		{
			try {
				new RegExp( regexString );
			} catch( err ) {
				if( showMessage )
					alert( `Regex is Invalid: ${err.message}` );
				return false;
			}
			if( showMessage )
				alert( `Regex is Valid!` );
			return true;
		},
		isAnyValidator( )
		{
			for( let i=0; i < arguments.length; i++ )
				if( arguments[i] == this.item.validator )
					return true;
			return false;
		},
		getDateLocalISOString( value )
		{
			try {
				let month = value.getMonth( ) + 1;
				if( month < 10 ) month = "0"+ month;
				let day = value.getDate( );
				if( day < 10 ) day = "0"+ day;
				let hours = value.getHours( );
				if( hours < 10 ) hours = "0"+ hours;
				let minutes = value.getMinutes( );
				if( minutes < 10 ) minutes = "0"+ minutes;
				let seconds = value.getSeconds( );
				if( seconds < 10 ) seconds = "0"+ seconds;
				return value.getFullYear() +"-"+ month +"-"+ day +"T"+ hours +":"+ minutes +":"+ seconds;
			} catch( err ) { return ""; }
		},
		deleteThisItem( )
		{
			if( !confirm( "Are you sure you want to delete this validator?" ) )
				return;
			this.$delete( this.source, this.index );
		},
	}
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/SchemaFieldValidator.vue